import { routes } from "../generated/routes";

export const INVITE_WORKSPACE_PARAM = "invite_ws";
export const NO_WORKSPACE_PARAM = "no_ws";

type BuildInviteLinkArgs = {
  id: string;
  baseUrl: string;
  workspace?: string | null;
};

/**
 * Builds the org invite accept link. Invites created under a workspace carry it
 * as a search param so the accept route can send the user through SSO for that
 * workspace before accepting. Invites created outside of a workspace carry a
 * flag instead, so SSO can skip its workspace capture page for a user who has
 * no workspace to enter.
 */
export const buildInviteLink = ({
  id,
  baseUrl,
  workspace,
}: BuildInviteLinkArgs): string => {
  const url = new URL(routes.orgs.inviteAccept.replace(":id", id), baseUrl);

  if (workspace) url.searchParams.set(INVITE_WORKSPACE_PARAM, workspace);
  else url.searchParams.set(NO_WORKSPACE_PARAM, "true");

  return url.toString();
};
